module.exports = __webpack_public_path__ + "img/bronze_logo.5505a018.svg";